export const JITSI_DOMAIN = "lvt2.hwzthat.com";
export const AUTH_API = "https://hwzthat.com";
export const RETURN_URL = "https://hwzthat.com";
export const YOUTUBE_API_KEY = "AIzaSyC1Jv3EFkYCeHwV_EFde9nfiDi6TMu0PZI";